import React from 'react';
import BootstrapRow from 'react-bootstrap/Row';
import classNames from 'classnames';

// @ts-ignore TS(2322): Type 'null' is not assignable to type 'string'.
const Row = ({ children = null, className = null, ...otherProps }) => (
  <BootstrapRow {...otherProps} className={classNames('ws-ui-grid-row', className)}>
    {children}
  </BootstrapRow>
);

export default Row;
